import Logger from '../fw/logger';


export default class Mux {

  #rmp;
  #onErrorEmitMuxErrorFn = null;
  #shakaPlayerMux = null;

  constructor(rmp) {
    this.#rmp = rmp;
  }


  get shakaPlayer() {
    return this.#shakaPlayerMux;
  }

  #onErrorEmitMuxError() {
    window.mux.emit('#' + this.#rmp.id + ' .rmp-video', 'error', {
      player_error_code: this.#rmp.innerErrorData.code,
      player_error_message: this.#rmp.innerErrorData.message
    });
  }

  destroy() {
    this.#rmp.off('error', this.#onErrorEmitMuxErrorFn);
    if (this.#rmp.readingShaka) {
      try {
        this.#rmp.shakaPlayer.mux.destroy();
      } catch (warning) {
        console.warn(warning);
      }
    }
  }

  init() {
    this.#rmp.muxDataSettings.data.player_init_time = Date.now();
    if (typeof this.#rmp.muxDataSettings.data.player_name !== 'string' ||
      this.#rmp.muxDataSettings.data.player_name === '') {
      this.#rmp.muxDataSettings.data.player_name = 'radiantmediaplayer';
    }
    if (typeof this.#rmp.muxDataSettings.data.player_version !== 'string' ||
      this.#rmp.muxDataSettings.data.player_version === '') {
      this.#rmp.muxDataSettings.data.player_version = this.#rmp.playerVersion;
    }
  }

  initHlsJS() {
    if (typeof window.mux !== 'undefined') {
      this.#rmp.muxDataSettings.hlsjs = this.#rmp.hlsJS;
      this.#rmp.muxDataSettings.Hls = window.Hls;
      this.#onErrorEmitMuxErrorFn = this.#onErrorEmitMuxError.bind(this);
      this.#rmp.on('error', this.#onErrorEmitMuxErrorFn);
      Logger.print('mux data', 'adding hls.js data support', this.#rmp.muxDataSettings);
      window.mux.monitor('#' + this.#rmp.id + ' .rmp-video', this.#rmp.muxDataSettings);
    }
  }

  initShakaPlayer() {
    if (typeof window.initShakaPlayerMux !== 'undefined') {
      Logger.print('mux data', 'adding Shaka Player data support', this.#rmp.muxDataSettings);
      this.#shakaPlayerMux = window.initShakaPlayerMux(this.#rmp.shakaPlayer, this.#rmp.muxDataSettings);
    }
  }

  initHTML5() {
    Logger.print('mux data', 'adding HTML5 media element data support', this.#rmp.muxDataSettings);
    if (typeof window.mux !== 'undefined') {
      this.#onErrorEmitMuxErrorFn = this.#onErrorEmitMuxError.bind(this);
      this.#rmp.on('error', this.#onErrorEmitMuxErrorFn);
      window.mux.monitor('#' + this.#rmp.id + ' .rmp-video', this.#rmp.muxDataSettings);
    }
  }

}
